import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";
const VehicleTypeList = () => {

  const defaultColumns: any = [

    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
        <AccessControl
        children={
          <TableActionButton editPath={`edit/${getValue()}`} />
        }
        allowedPermissions={["can_update_setting"]}
        />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE_TYPE}
      queryKey={"vehicle-type"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"Vehicle Type"}
    />
  );
};

export default VehicleTypeList;
